export default __webpack_public_path__ + "static/media/covetrus-documentation.6c034082.pdf";